import { render, staticRenderFns } from "./ControlEditor.vue?vue&type=template&id=08504683&scoped=true"
import script from "./ControlEditor.vue?vue&type=script&lang=js"
export * from "./ControlEditor.vue?vue&type=script&lang=js"
import style0 from "./ControlEditor.vue?vue&type=style&index=0&id=08504683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08504683",
  null
  
)

export default component.exports